import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doCheckUserSubscriptionSaga),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doPollForSubscription),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doStartPollingForSubscription),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(watchIdealLandingSagas);

import { fetchEntity } from '@classpass/saga-tools';
import * as logger from 'universal-logger';
import { push as updatePath, LOCATION_CHANGE } from 'react-router-redux';
import { delay } from 'redux-saga';
import { select, call, fork, put, race, take, takeEvery } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { memberStatus } from 'enums/memberStatus';
import { userProfile } from 'redux/saga/entities/bound';
export var POLLING_INTERVAL = 5000;
export var START_POLLING_FOR_SUBSCRIPTION = 'features/Purchase/START_POLLING_FOR_SUBSCRIPTION';
export var startPollingForSubscription = function startPollingForSubscription() {
  return {
    type: START_POLLING_FOR_SUBSCRIPTION
  };
};
export function doCheckUserSubscriptionSaga(client) {
  var profile, status;
  return regeneratorRuntime.wrap(function doCheckUserSubscriptionSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(fetchEntity, userProfile, [client]);

        case 2:
          profile = _context.sent;
          status = profile.membership.status;
          return _context.abrupt("return", memberStatus('ACTIVE') === status);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doPollForSubscription(client) {
  var hasActiveSubscription;
  return regeneratorRuntime.wrap(function doPollForSubscription$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return select(isLoggedIn);

        case 3:
          if (!_context2.sent) {
            _context2.next = 16;
            break;
          }

        case 4:
          if (!true) {
            _context2.next = 16;
            break;
          }

          _context2.next = 7;
          return call(doCheckUserSubscriptionSaga, client);

        case 7:
          hasActiveSubscription = _context2.sent;

          if (!hasActiveSubscription) {
            _context2.next = 12;
            break;
          }

          _context2.next = 11;
          return put(updatePath('/'));

        case 11:
          return _context2.abrupt("return", _context2.sent);

        case 12:
          _context2.next = 14;
          return call(delay, POLLING_INTERVAL);

        case 14:
          _context2.next = 4;
          break;

        case 16:
          _context2.next = 22;
          break;

        case 18:
          _context2.prev = 18;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 22;
          return call(logger.warn, 'IdealLanding: Could not poll user for subscription', _context2.t0);

        case 22:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 18]]);
}
export function doStartPollingForSubscription(client) {
  return regeneratorRuntime.wrap(function doStartPollingForSubscription$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return race([call(doPollForSubscription, client), take(LOCATION_CHANGE)]);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function watchIdealLandingSagas(client) {
  return regeneratorRuntime.wrap(function watchIdealLandingSagas$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return fork(takeEvery, START_POLLING_FOR_SUBSCRIPTION, doStartPollingForSubscription, client);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}